export default __webpack_public_path__ + "static/media/nintendo.2da7b4da.svg";